import Spinner from '@berlitz/spinner'
import React from 'react'
import { LoaderWrapper, SpinnerWrapper } from './style'

const InstructorsLoader = () => {
  return (
    <LoaderWrapper>
      <SpinnerWrapper>
        <Spinner />
      </SpinnerWrapper>
    </LoaderWrapper>
  )
}

export default InstructorsLoader
